
import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { blogPosts } from '../data/blog-posts';
import { BookOpen } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

const BlogPost = () => {
  const { id } = useParams();
  const post = blogPosts.find(post => post.id === id);

  if (!post) {
    return (
      <Layout>
        <div className="container-custom py-20">
          <h1 className="text-2xl font-bold">Post not found</h1>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <article className="py-20">
        <div className="container-custom max-w-4xl">
          {post.imageUrl && (
            <div className="relative h-[400px] rounded-xl overflow-hidden mb-8">
              <img 
                src={post.imageUrl} 
                alt={post.title}
                className="w-full h-full object-cover"
              />
            </div>
          )}

          <div className="prose prose-pink dark:prose-invert max-w-none">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 dark:text-white">
              {post.title}
            </h1>

            <div className="flex items-center gap-6 text-gray-500 dark:text-gray-400 mb-8">
              <div className="flex items-center gap-2">
                <span className="font-medium">{post.author}</span>
                <span>•</span>
                <span>{post.date}</span>
              </div>
              <div className="flex items-center">
                <BookOpen className="h-4 w-4 mr-1" />
                <span>{post.readTime}</span>
              </div>
            </div>

            <ReactMarkdown>
              {post.content}
            </ReactMarkdown>

            <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700">
              <div className="flex flex-wrap gap-2">
                {post.tags.map((tag) => (
                  <span 
                    key={tag}
                    className="inline-block px-3 py-1 text-sm font-medium bg-pink-100 text-fembot-pink rounded-full dark:bg-pink-900/30"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </article>
    </Layout>
  );
};

export default BlogPost;
